import { gql } from '@apollo/client';

export const b2bMemberName = 'B2BMember';
export const b2bMember = gql`
	fragment ${b2bMemberName} on Member {
		b2b {
			kind
			customer {
				id
				name
			}
		}
	}
`;
